import { Overview } from '../components/dreamHome/shared/overview/OverviewBlock';
import { PropertyRequest, TicketRatesDiscount } from '../types/property';
import { PropertyImagesParams } from '../types/propertyImages';
import { Raffle, RaffleRequest } from '../types/raffle';
import getGalleryImages from './getGalleryImages';

interface PropertyData {
  property: PropertyRequest;
  images: PropertyImagesParams;
}

export const compilePropertyRequest = (
  data: PropertyRequest,
  overviews: Array<Overview>
): PropertyData => {
  const property: PropertyRequest = {
    filesGallery: data.filesGallery,
    filesGalleryMobile: data.filesGalleryMobile,
    galleryImages: [],
    galleryImagesMobile: [],
    floorPlanImage: data.filesFloorPlan?.key || '',
    locationMapImage: data.filesMapImage?.key || '',
    badroomImage: data.filesBedroom?.key || '',
    bathroomImage: data.filesBathroom?.key || '',
    outspaceImage: data.filesOutspace?.key || '',
    cardImage: data.filesCard?.key || '',
    mobileCardImage: data.filesMobileCard?.key || '',
    emailGalleryImage: data.filesEmailGallery?.key || '',
    bathroomText: data.bathroomText ? data.bathroomText : '',
    bedroomText: data.bedroomText ? data.bedroomText : '',
    description: data.description ? data.description : '',
    outspaceText: data.outspaceText ? data.outspaceText : '',
    pixangleSource: data.pixangleSource ? data.pixangleSource : '',
    generalText: data.generalText || '',
    heading: data.heading || '',
    overview: overviews,
    location: data.location,
    latitude: data.latitude,
    longitude: data.longitude,
    tourLink: data.tourLink,
    _id: data._id,
  };
  let images: PropertyImagesParams = {
    galleryImages: [],
    galleryImagesMobile: [],
    floorPlanImage: undefined,
    locationMapImage: undefined,
    badroomImage: undefined,
    bathroomImage: undefined,
    outspaceImage: undefined,
    cardImage: undefined,
    emailGalleryImage: undefined,
  };
  if (data.filesGallery) {
    images.galleryImages = getGalleryImages(data.filesGallery);
  }
  if (data.filesGalleryMobile) {
    images.galleryImagesMobile = getGalleryImages(data.filesGalleryMobile);
  }
  if (data.filesFloorPlan) {
    images.floorPlanImage = data.filesFloorPlan.rawFile;
  }
  if (data.filesMapImage) {
    images.locationMapImage = data.filesMapImage.rawFile;
  }
  if (data.filesBedroom) {
    images.badroomImage = data.filesBedroom.rawFile;
  }
  if (data.filesBathroom) {
    images.bathroomImage = data.filesBathroom.rawFile;
  }
  if (data.filesOutspace) {
    images.outspaceImage = data.filesOutspace.rawFile;
  }
  if (data.filesCard) {
    images.cardImage = data.filesCard.rawFile;
  }
  if (data.filesMobileCard) {
    images.mobileCardImage = data.filesMobileCard.rawFile;
  }
  if (data.filesEmailGallery) {
    images.emailGalleryImage = data.filesEmailGallery.rawFile;
  }

  const propertyData: PropertyData = {
    property: property,
    images: images,
  };
  property.galleryImages = [];
  property.galleryImagesMobile = [];
  return propertyData;
};

export const CompileRaffleRequest = (
  data: Raffle,
  propertyId: string,
  discountRates: Array<TicketRatesDiscount> | undefined
): RaffleRequest => {
  const raffle: RaffleRequest = {
    active: data.active || false,
    isActiveDiscount: data.isActiveDiscount || false,
    isPopular: data.isPopular || false,
    isTrending: data.isTrending || false,
    name: data.name,
    endsAt: new Date(data.endsAt).toISOString(),
    startAt: new Date(data.startAt).toISOString(),
    ticketPrice: parseFloat(data.ticketPrice.toFixed(2)),
    defaultTickets: data.defaultTickets,
    property: propertyId,
    isDiscountRates: data.isDiscountRates || false,
    creditsRates: data.creditsRates,
    creditsEndDate: data.creditsEndDate,
    creditsStartDate: data.creditsStartDate,
    isCreditsActive: data.isCreditsActive,
    isCreditsPermanent: data.isCreditsPermanent,
    discountRates: data.isDiscountRates ? discountRates : [],
    discountTicket: data.discountTicket,
    discountCategory: data.discountCategory,
    freeTicketsRates: data.isFreeTicketsRates ? data.freeTicketsRates : [],
    isFreeTicketsRates: data.isFreeTicketsRates,
    ticketsBundles: data.ticketsBundles,
    title: data.title.replace(/\s+/g, ' ').trim() || 'London',
    bundleTitle: data.bundleTitle ? data.bundleTitle : '',
    metaTitle: data.metaTitle,
    metaDescription: data.metaDescription,
    stepperCountdown: {
      isActive: data.stepperCountdown.isActive
        ? data.stepperCountdown.isActive
        : false,
      title: data.stepperCountdown.title ? data.stepperCountdown.title : '',
      startAt: data.stepperCountdown.startAt
        ? data.stepperCountdown.startAt
        : new Date().toISOString(),
      endsAt: data.stepperCountdown.endsAt
        ? data.stepperCountdown.endsAt
        : new Date().toISOString(),
    },
    description: data.property.description || '',
  };

  return raffle;
};
